module.exports = "../static/images/692e66.png";